import { Loader } from '@googlemaps/js-api-loader';

/**
 * Google Map
 * ======================================
 * <div class="map js-map" data-lat="49.84306953594377" data-lng="14.525088870187364"></div>
 * https://developers.google.com/maps/documentation/javascript/tutorial
 *
 */

 // const markers = [
//   {"title": "Rudná", "lat": 49.8037633, "lng": 15.4749126},
//   {"title": "Benešov", "lat": 49.8537633, "lng": 15.7749126, "large": true},
//   {"title": "Kladno", "lat": 49.8837633, "lng": 15.3749126}
// ]

const API_KEY = 'AIzaSyBCdmteGvr_OlnPH71jMQPvMcnG33uvAHU'
const WIDGET = '.js-map'

class Map {
	constructor() {
    this.element = document.querySelector(WIDGET)
    this.lat = parseFloat(this.element.getAttribute('data-lat'))
    this.lng = parseFloat(this.element.getAttribute('data-lng'))
    this.marker = 'images/marker.svg'
    this.mapOptions = {
			zoom: 16,
			center: { lat: this.lat, lng: this.lng },
			disableDefaultUI: true,
			zoomControl: true,
			scrollwheel: false
    }

		if (!this.element || !this.lat || !this.lng) {
			return false
    }

    const loader = new Loader({
      apiKey: API_KEY,
      version: "weekly"
    });

    loader.load().then(() => {
      this.initMap()
    })
    .catch(e => {
      console.log('Mapu nelze načíst.', e)
    });
  }

  initMap = () => {
    const map = new google.maps.Map(this.element, this.mapOptions)

    /**
		* Styled map
		*/
		const styledMapType = new google.maps.StyledMapType(this.getStyles())

		map.mapTypes.set('customMapStyle', styledMapType)
		map.setMapTypeId('customMapStyle')

		const iconSvg = {
			url: '/app/themes/ipress/build/'+this.marker,
			scaledSize: new google.maps.Size(179, 46)
		}

		const iconSvgLarge = {
			url: '/app/themes/ipress/build/'+this.marker,
			scaledSize: new google.maps.Size(33, 47)
		}

		if (typeof markers !== 'undefined') {
			markers.forEach(item => {
				const marker = new google.maps.Marker({
					// icon: item.large ? iconSvgLarge : iconSvg,
					optimized: false,
					title: item.title,
					position: { lat: item.lat, lng: item.lng }
				})
				marker.setMap(map)
			})
		} else {
      const marker = new google.maps.Marker({
        // icon: iconSvg,
        optimized: false,
        position: { lat: this.lat, lng: this.lng }
      })
      marker.setMap(map)
    }
  }

  // https://mapstyle.withgoogle.com/
	getStyles = () => {
    return [
      {
          "featureType": "landscape.man_made",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#f7f1df"
              }
          ]
      },
      {
          "featureType": "landscape.natural",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#d0e3b4"
              }
          ]
      },
      {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "labels",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "poi.business",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#bde6ab"
              },
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#ffe15f"
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "color": "#efd151"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#ffffff"
              }
          ]
      },
      {
          "featureType": "road.local",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "black"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#a2daf2"
              }
          ]
      }
  ]
	}
}

new Map()

